import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from "vue";

import { HeaderNavigationLink } from "@/models/header.model";


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderLink',
  props: {
  link: {
    required: true,
    type: Object as PropType<HeaderNavigationLink>
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    "data-testing": __props.link.dataTesting,
    class: _normalizeClass(['header-link', { highlighted: __props.link.isHighlighted }]),
    to: __props.link.to
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.link.title), 1)
    ]),
    _: 1
  }, 8, ["data-testing", "class", "to"]))
}
}

})